import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import PubSub from 'pubsub-js';
import axios from 'axios';
import queryString from 'query-string';
import { toastr } from "react-redux-toastr";

export default ({ bookingId, billId, user }) => {
  const [disabled, setDisabled] = useState(false);
  const prevUserRef = useRef(null);

  useEffect(() => {
    if (prevUserRef.current !== null && prevUserRef.current !== user && user.isLoggedIn) {
      process();
    }

    prevUserRef.current = user;
  }, [user]);

  const process = () => {
    setDisabled(true);
    if (disabled) return;

    if (!user.isLoggedIn()) {
      PubSub.publish('Devise.SignIn', { autoProcess: true, modalTitle: 'Sign In' });
      setDisabled(false);
      return true;
    }

    const query = queryString.parse(location.search);
    const data = { booking_user_id: query.user_id };

    axios
      .post(`/bookings/${bookingId}/bills/${billId}/prepare`, data)
      .then((response) => {
        window.location = `/bookings/${response.data.data.booking_id}/checkout`;
      })
      .catch((error) => {
        setDisabled(false);

        if (error.response.status === 422) {
          toastr.error('', (error.response.data?.errors?.base || []).join(', '));
        } else {
          toastr.error('', 'Something went wrong');
        }
      });
  };

  return (
    <Button bsStyle="primary" disabled={disabled} onClick={process}>
      PROCEED TO CHECKOUT
    </Button>
  );
}